import { Box, Flex, IconButton, InputGroup, InputRightElement, Radio } from '@chakra-ui/react'
import helperTexts from '../../helperTexts.json'
import { StyledInput, UnderlineError } from "../styled";
import { Controller } from "react-hook-form";
import { hostPortRegex } from "../formUtils";
import { useEffect } from "react";
import { FiPlus, FiX } from 'react-icons/fi';
import { FormLabel } from '../../common/FormLabel';

export const SocketConnectHostPort = ({
    field,
    isAcceptor,
    setValue,
    fields,
    append,
    remove,
    form,
    control,
    errors
}) => {
    useEffect(() => {
        if (isAcceptor && errors['socketConnectHostPort']) {
            form.clearErrors('socketConnectHostPort')
        }
    }, [isAcceptor, errors, form])

    const isDisabled = field.isDisabled

    return (
    <Box width="320px" fontWeight='500'>
        <Radio
            size="md"
            name="1"
            marginBottom={2}
            isDisabled={isDisabled}
            isChecked={!isAcceptor}
            onChange={(e) => setValue('connectionType', e.target.checked ? 'initiator' : 'acceptor')}
        >
            Initiator
        </Radio>
        <FormLabel
            required
            disabled={isAcceptor || isDisabled}
            helperText={helperTexts.socketConnectHostPort}
        >
            {field.label}
        </FormLabel>
        <Box display="flex" flexDir="column" justifyContent="center" sx={{ width: '100%' }}>
            {fields.map((field, index) => (
                <Box>
                <Flex alignItems="center">
                    <Controller
                        name={`socketConnectHostPort.${index}.value`}
                        control={control}
                        rules={{
                            required: !isAcceptor,
                            validate: () => {
                                if (!isAcceptor && !form.getValues('socketConnectHostPort')[index].value.match(hostPortRegex)) {
                                    return 'Incorrect format. Should be "host:port"'
                                }
                                return true
                            }
                        }}
                        render={({ field }) => (
                            <InputGroup>
                                <StyledInput 
                                    {...field}
                                    style={{ font: 'var(--code-font)' }}
                                    marginBottom={2}
                                    key={field.id}
                                    placeholder="host:port"
                                    isDisabled={isAcceptor || isDisabled}
                                    isInvalid={!!errors['socketConnectHostPort'] && !!errors['socketConnectHostPort'][index]}
                                />    
                                {index !== 0 && (
                                    <InputRightElement>
                                        <IconButton
                                            variant='ghost'
                                            margin="8px"
                                            size="xs"
                                            isDisabled={isAcceptor || isDisabled}
                                            onClick={() => remove(index)}
                                            icon={<FiX size="20px" />}
                                        />
                                    </InputRightElement>
                                )}
                            </InputGroup>
                            
                        )}
                    />
                </Flex>
                    {!!errors['socketConnectHostPort']
                        && !!errors['socketConnectHostPort'][index]
                        && <UnderlineError>{
                            errors['socketConnectHostPort'][index].value.type === 'required'
                                ? 'Required'
                                : errors['socketConnectHostPort'][index].value.message}
                           </UnderlineError>}
                </Box>
            ))}
            <IconButton
                margin="auto"
                size="sm"
                mt={2}
                isDisabled={isAcceptor || isDisabled}
                onClick={(e) => {
                    e.preventDefault()
                    append({ value: '' })
                }}
                icon={<FiPlus strokeWidth={3}/>}
            />
        </Box>
    </Box>)
}
